function isPositiveSafeInteger(value: number): boolean {
  return Number.isSafeInteger(value) && value > 0
}

function revisionSuffix(revision: number | undefined): string {
  if (revision === undefined) {
    return ""
  }
  if (!Number.isSafeInteger(revision) || revision < 0) {
    throw new RangeError("revision must be a non-negative safe integer")
  }
  return `&revision=${revision}`
}

export function createAnnouncementsPath(limit: number, offset: number, revision?: number): string {
  if (!Number.isInteger(limit) || limit < 1 || limit > 100) {
    throw new RangeError("limit must be an integer between 1 and 100")
  }
  if (!Number.isInteger(offset) || offset < 0 || offset > 10_000) {
    throw new RangeError("offset must be an integer between 0 and 10000")
  }
  return `/api/v1/announcements?limit=${limit}&offset=${offset}${revisionSuffix(revision)}`
}

export function createAnnouncementDetailPath(id: number, revision?: number): string {
  if (!isPositiveSafeInteger(id)) {
    throw new RangeError("id must be a positive integer")
  }
  const suffix = revisionSuffix(revision)
  return `/api/v1/announcements/${id}${suffix ? `?${suffix.slice(1)}` : ""}`
}

export function createAnnouncementBannerPath(limit: number, revision?: number): string {
  if (!Number.isInteger(limit) || limit < 1 || limit > 20) {
    throw new RangeError("limit must be an integer between 1 and 20")
  }
  return `/api/v1/banner?limit=${limit}${revisionSuffix(revision)}`
}
